import Div from '@/shared/Div';
import Paragraph from '@/shared/Paragraph';
import React from 'react';
import PointerDownwardTriangle from '../Icons/PointerDownwardTriangle';
import classNames from 'classnames';

type LocationToolTipProps = {
  className?: string;
  dataTestId?: string;
};
function ServiceLocationToolTip({ className, dataTestId }: LocationToolTipProps) {
  return (
    <Div
      dataTestId={dataTestId}
      className={classNames(
        'py-s3 px-s4  bg-primary-black flex flex-col relative border rounded-cxs ',
        className,
      )}
    >
      <Paragraph className="text-white  text-callout-small">
        Our technician will arrive here
      </Paragraph>
      <Paragraph className="text-white text-body-sm">Move your pin to the exact location</Paragraph>
      <PointerDownwardTriangle className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-full" />
    </Div>
  );
}

export default ServiceLocationToolTip;
